import ResidentsScreen from './ResidentsScreen'
import { useSelector } from 'react-redux'
import { Home } from '@lmc/ts-common'
import useHomeType from 'hooks/useHomeType'
import useFeatureFlags from 'hooks/useFeatureFlags'

export const ResidentScreenFeatureFlagWrapper = () => {
  const { hasRota } = useHomeType()

  const home = useSelector(
    (state: { global: { home: Home } }) => state?.global?.home
  )

  const flags = useFeatureFlags({
    flagNames: ['communication_records', 'emar_v2_chart', 'procedures']
  })?.data

  const hasLegacyMedications = home?.features?.carePlanMeds?.enabled
  const communicationRecordsEnabled = flags?.communication_records?.enabled
  const proceduresEnabled = flags?.procedures?.enabled ?? false
  const emarChartV2Enabled = flags?.emar_v2_chart?.enabled

  return (
    <ResidentsScreen
      hasLegacyMedications={hasLegacyMedications}
      hasRota={hasRota}
      communicationRecordsEnabled={communicationRecordsEnabled}
      proceduresEnabled={proceduresEnabled}
      emarChartV2Enabled={emarChartV2Enabled}
      data-testid="residents-screen-wrapper"
    />
  )
}
